import { OrganizationKeyName } from "../../../model/Organization";
import { ProductCategoryListItem } from "../../product-categories/models/product-category";

export const GET_PRODUCT_CATEGORY_LIST_SUCCESS =
  "SHOP:GET_PRODUCT_CATEGORY_LIST_SUCCESS";

export const getProductCategoryListSuccessAction = (
  organization: OrganizationKeyName,
  data: ProductCategoryListItem[]
) => ({
  type: GET_PRODUCT_CATEGORY_LIST_SUCCESS as typeof GET_PRODUCT_CATEGORY_LIST_SUCCESS,
  organization,
  data,
});

export type GetProductCategoryListSuccessAction = ReturnType<
  typeof getProductCategoryListSuccessAction
>;
